import { useEffect, useState, useMemo } from 'react'

import {
  IS_ADMIN,
  IS_HIRING_ADVISOR,
  ITEMS_PER_PAGE,
  NOT_AVAILABLE,
  OUT_OF_THE_APP,
  VIEWPORT_LG,
} from '../../utils/constants'

import { Link, useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import HeartIconTwo from '../../icons/HeartIconTwo'
import Divider from '../../components/Divider'
import Badge from '../../components/Badge/Badge'
import CalendarIcon from '../../icons/CalendarIcon'
import TranslateIconTwo from '../../icons/TranslateIconTwo'
import { getMyOffersManagement } from '../../services/OfferManagement'
import { TAGS } from '../../services/Tags'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import SearchUserOutlineExtraSmallIcon from '../../icons/SearchUserOutlineExtraSmallIcon'
import Button from '../../components/Button'
import InitWhatsappChatButton from '../../components/Whatsapp/InitWhatsappChatButton'
import Swal from 'sweetalert2'
import Pagination from '../../components/Pagination'
import HeartRedIcon from '../../icons/HeartRedIcon'
import {
  addFavoriteByHA,
  addMultipliesFavorites,
  removeFavorite,
} from '../../services/Favorites'
import {
  addFavoriteByAdmin,
  getListOfValidateFastOffers,
  removeFavoriteByAdmin,
} from '../../services/Admin'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { PdfToDownload } from '../pdf/PdfToDownload'
import withReactContent from 'sweetalert2-react-content'
import PdfIcon from '../../icons/PdfIcon'
import { useTranslation } from 'react-i18next'
import {
  useListOfTalentsBySuperSearchStore,
  useViewedTalentsStore,
  useTalentFavoritesStore,
} from '../../store'
import { CALENDLY_API_URL } from '../../services/constants'
import Loader from '../../components/Loader'
import Toast from '../../components/Toast/Toast'
import useResize from '../../hooks/useResize'
import {
  getOffersByCompany,
  listOfCompaniesByHiringAdvisor,
} from '../../services/HiringAdvisor'
import { CANDIDATES_TAGS } from '../../services/Tags/candidates'

const TalentCard = ({
  talen_skills = [],
  name_category_job = '',
  languaje_lang_levels = {},
  favorites_v2s = null,
  favorites_offers_orders = null,
  isFavorite = true,
  showStatus = true,
  years = {},
  create_date = '',
  user = {},
  views = [],
  id: idTalent = '',
  data,
  isBanner = false,
  bannerUrl = '',
  isJuniorView = false,
  status_talent_name = '',
  onFavoriteChange = null,
}) => {
  const [showFloatingOffers, setShowFloatingOffers] = useState(false)
  const { t } = useTranslation()
  const viewportSize = useResize()
  const MySwal = withReactContent(Swal)
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const { id } = useListOfTalentsBySuperSearchStore()
  const { addViewedTalent, isViewed } = useViewedTalentsStore()
  const { setFavorites } = useTalentFavoritesStore()
  const totalElementsToShow = 3
  const showSkills = talen_skills?.length > totalElementsToShow
  const LS_KEY = `temp_favorites_${idTalent}`
  const [localFavorites, setLocalFavorites] = useState(favorites_v2s ?? [])
  const checkOffersFavorite = localFavorites.map(({ offer_id }) => offer_id)
  const newFavorite = localFavorites.length > 0
  const [search, setSearch] = useState('')

  useEffect(() => {
    setLocalFavorites(favorites_v2s ?? [])
    localStorage.removeItem(LS_KEY)
  }, [favorites_v2s])
  const [selectCompanyByHA, setSelectCompanyByHA] = useState(null)
  const [page, setPage] = useState(0)
  const elementsToShow = talen_skills?.slice(0, totalElementsToShow)
  const talentDate = dayjs(create_date)?.format('DD-MM-YYYY')
  const today = dayjs().format('DD-MM-YYYY')
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  const { data: companyOffersData = [] } = useQuery(
    [TAGS.offers_company, page, search],
    () =>
      IS_ADMIN
        ? getListOfValidateFastOffers({ page })
        : getMyOffersManagement({ page, search, isHutritNext: isJuniorView }),
    {
      enabled: !OUT_OF_THE_APP,
    }
  )

  const { data: getOffersByCompanyData = [] } = useQuery(
    ['offers-by-company-ha', page, search, selectCompanyByHA],
    () => getOffersByCompany({ page, search, companyId: selectCompanyByHA }),
    {
      enabled: !OUT_OF_THE_APP && !!selectCompanyByHA,
    }
  )

  const {
    data: listOfCompaniesByHiringAdvisorData = {},
    isLoading: isLoadingListOfCompaniesByHiringAdvisor,
  } = useQuery(['list-comapnies-ha'], listOfCompaniesByHiringAdvisor, {
    enabled: !OUT_OF_THE_APP && IS_HIRING_ADVISOR,
  })

  const favoriteCompanyIds = useMemo(
    () => new Set(localFavorites.map(({ company }) => company?.id).filter(Boolean)),
    [localFavorites]
  )

  const favoriteCompanies = useMemo(() => {
    if (!IS_HIRING_ADVISOR || favoriteCompanyIds.size === 0) return []
    return (listOfCompaniesByHiringAdvisorData?.list ?? []).filter(
      ({ id }) => favoriteCompanyIds.has(id)
    )
  }, [listOfCompaniesByHiringAdvisorData, favoriteCompanyIds])

  const listOfJobsOffer = useMemo(() => {
    let data
    if (IS_HIRING_ADVISOR && selectCompanyByHA) {
      data = getOffersByCompanyData
    } else {
      data = companyOffersData
    }
    if (data?.offers) {
      let filteredOffers = [...data.offers].sort(
        (a, b) => new Date(b.date_create) - new Date(a.date_create)
      )
      if (search) {
        filteredOffers = filteredOffers.filter(
          (offer) =>
            offer.name?.toLowerCase().includes(search.toLowerCase().trim()) ||
            offer.position
              ?.toLowerCase()
              .includes(search.toLowerCase().trim()) ||
            offer.category_job?.name
              ?.toLowerCase()
              .includes(search.toLowerCase().trim())
        )
      }
      return {
        ...data,
        offers: filteredOffers,
      }
    }
    return data
  }, [
    IS_HIRING_ADVISOR,
    selectCompanyByHA,
    getOffersByCompanyData,
    companyOffersData,
    search,
  ])

  const {
    mutate: addFavoriteMutate,
    isLoading: isLoadingAddFavorite,
    variables: addFavoriteVariables,
    reset: addFavoriteReset,
  } = useMutation(
    [TAGS.add_favorite],
    IS_ADMIN
      ? addFavoriteByAdmin
      : IS_HIRING_ADVISOR
      ? addFavoriteByHA
      : addMultipliesFavorites,
    {
      onSuccess: (response) => {
        const existingIds = new Set((favorites_v2s ?? []).map(({ id }) => id))
        const newFavoriteFromServer = response?.favorites?.find(
          (f) => !existingIds.has(f.id)
        )
        if (newFavoriteFromServer) {
          const stored = JSON.parse(localStorage.getItem(LS_KEY) ?? '[]')
          const updated = stored.filter(({ offer_id }) => offer_id !== newFavoriteFromServer.offer_id)
          localStorage.setItem(LS_KEY, JSON.stringify([...updated, newFavoriteFromServer]))
        }
        onFavoriteChange?.(response?.favorites)
        queryClient.invalidateQueries([TAGS.user_resumen_data])
        queryClient.invalidateQueries([TAGS.match_job_offer_ha])
        queryClient.invalidateQueries([CANDIDATES_TAGS.list_Of_Candidates_two])
        addFavoriteReset()
        Toast({ title: 'Agregado a favoritos exitosamente' })
      },
    }
  )

  const {
    mutate: removeFavoriteMutate,
    isLoading: isLoadingRemoveFavorite,
    variables: removeFavoriteVariables,
    reset: removeReset,
  } = useMutation(
    [TAGS.remove_favorite],
    IS_ADMIN ? removeFavoriteByAdmin : removeFavorite,
    {
      onSuccess: (_, variables) => {
        const removedOfferId = variables?.idsOffer?.[0] ?? variables?.offerId
        if (removedOfferId) {
          const stored = JSON.parse(localStorage.getItem(LS_KEY) ?? '[]')
          localStorage.setItem(
            LS_KEY,
            JSON.stringify(stored.filter(({ offer_id }) => offer_id !== removedOfferId))
          )
        }
        onFavoriteChange?.((favorites_v2s ?? []).filter(({ offer_id }) => offer_id !== removedOfferId))
        removeReset()
        Toast({ title: 'Removido de favoritos exitosamente' })
        queryClient.invalidateQueries([TAGS.user_resumen_data])
        queryClient.invalidateQueries([TAGS.match_job_offer_ha])
        queryClient.invalidateQueries([CANDIDATES_TAGS.list_Of_Candidates_two])
      },
    }
  )

  const handleOfferSelect = ({ id }) => {
    const filterIds = favorites_offers_orders?.find(
      ({ offert_id }) => offert_id === id
    )
    const storedFavorites = JSON.parse(localStorage.getItem(LS_KEY) ?? '[]')
    const transformDataToRemoveFavorite =
      (favorites_v2s ?? []).find(({ offer_id }) => offer_id === id)?.id ??
      storedFavorites.find(({ offer_id }) => offer_id === id)?.id

    const companyData = {
      idTalent,
      idsOffer: [Number(id)],
    }

    const hiringAdvisorData = {
      talentId: idTalent,
      companyId: selectCompanyByHA,
      offerId: Number(id),
    }

    const adminData = {
      idTalent,
      idOffer: id,
    }

    const companyRemoveId = {
      talentId: idTalent,
      IdsFavorites: [transformDataToRemoveFavorite],
      idsOffer: [Number(id)],
      ...(IS_HIRING_ADVISOR && { companyId: selectCompanyByHA }),
    }

    const adminRemoveId = {
      id: filterIds?.id,
    }

    const renderData = IS_ADMIN
      ? adminData
      : IS_HIRING_ADVISOR
      ? hiringAdvisorData
      : companyData

    const renderRemoveFavoriteData = IS_ADMIN ? adminRemoveId : companyRemoveId

    if (checkOffersFavorite?.includes(id)) {
      setLocalFavorites((prev) => prev.filter(({ offer_id }) => offer_id !== id))
      removeFavoriteMutate(renderRemoveFavoriteData)
    } else {
      setLocalFavorites((prev) => [...prev, { offer_id: id, id: Date.now() }])
      addFavoriteMutate(renderData)
    }
  }

  const handleGoToReviewProfile = () => {
    addViewedTalent(idTalent)
    setFavorites(favorites_v2s ?? [])
    if (isJuniorView) {
      navigate(`/talent-juniors/${idTalent}`)
    } else {
      navigate(`/talent/${idTalent}`)
    }
  }

  const handleDownloadPdf = (talentId) => {
    const findInformation = data?.find(
      (props) => Number(props?.id) === Number(talentId)
    )

    MySwal.fire({
      title: <PdfIcon />,
      showConfirmButton: false,
      html: (
        <>
          <PDFDownloadLink
            document={<PdfToDownload data={findInformation} />}
            fileName={`${findInformation?.user.username}_work_experience.pdf`}
          >
            <Button>{t('download_pdf')}</Button>
          </PDFDownloadLink>
        </>
      ),
    })
  }

  // Remove outside click logic for collapse
  useEffect(() => {
    if (!showFloatingOffers) return
    const handleOutsideClick = (event) => {
      // Only close if click is outside the floating offers div or heart icon
      if (
        !event.target.closest('.floating-offers') &&
        !event.target.closest('.heart-icon')
      ) {
        setShowFloatingOffers(false)
      }
    }
    document.addEventListener('mousedown', handleOutsideClick)
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [showFloatingOffers])

  return isBanner ? (
    <Link target="_blank" to={CALENDLY_API_URL}>
      <img src={bannerUrl ?? ''} width="100%" className="mb-2" />
    </Link>
  ) : (
    <div
      className={`${
        id === idTalent
          ? 'border-bg-CTA-primary bg-bg-success-pressed'
          : 'bg-white'
      } zoom border rounded mb-2 text-on-bg-primary p-2 position-relative`}
      style={{
        width: '100%',
      }}
    >
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex flex-column">
          <span className="fw-bold">{name_category_job || NOT_AVAILABLE}</span>
          <span className="font-small">{user?.username}</span>
        </div>
        <div className="d-flex align-items-center gap-2">
          {showStatus && talentDate === today && (
            <span className="badge bg-bg-brand rounded-pill p-2">
              {t('new')}
            </span>
          )}
          {showStatus && (views.length > 0 || isViewed(idTalent)) && (
            <span className="badge  bg-on-bg-CTA-primary-selected  text-white rounded-pill p-2">
              {t('seen')}
            </span>
          )}
          {status_talent_name && (
            <span className="badge bg-secondary bg-opacity-10 text-secondary border border-secondary border-opacity-25 rounded-pill p-2">
              {status_talent_name}
            </span>
          )}
          <Badge className="border text-on-bg-Success bg-bg-Success rounded-pill p-2">
            {t('available')}
          </Badge>
          {isFavorite && (
            <div>
              {' '}
              {!OUT_OF_THE_APP && (
                <>
                  {(IS_HIRING_ADVISOR) && (
                    <div
                      className="p-1 cursor-pointer heart-icon"
                      title={'Agregar a favoritos'}
                      onClick={() => {
                        setShowFloatingOffers((prev) => !prev)
                        setSelectCompanyByHA(null)
                      }}
                    >
                      {newFavorite ? <HeartRedIcon /> : <HeartIconTwo />}
                    </div>
                  )}
                  {/* Floating offers div */}
                  {showFloatingOffers && (
                    <div
                      className="floating-offers border rounded bg-white shadow-sm"
                      style={{
                        position: 'absolute',
                        right: 0,
                        zIndex: 30,
                        width: isMobile ? '100%' : '60%',
                        top: '40px', // adjust as needed to appear below heart
                      }}
                    >
                      {IS_HIRING_ADVISOR && !selectCompanyByHA && (
                        <div className="px-3 pt-3">
                          <span className="text-on-bg-secondary">
                            Seleccionar empresa
                          </span>
                          <ul className="list-unstyled">
                            {listOfCompaniesByHiringAdvisorData?.list
                              ?.filter(({ name }) => name !== null)
                              .map(({ id, name, offers_count }) => {
                                return (
                                  <li
                                    key={id}
                                    className="d-flex justify-content-between align-items-center gap-2 mb-1 cursor-pointer"
                                    onClick={() => setSelectCompanyByHA(id)}
                                  >
                                    {isLoadingListOfCompaniesByHiringAdvisor ? (
                                      <Loader />
                                    ) : (
                                      <>
                                        <div
                                          style={{
                                            width: '100%',
                                            overflow: isMobile ? '' : 'auto',
                                          }}
                                          className="d-flex align-items-center gap-2"
                                        >
                                          <span
                                            style={{
                                              fontSize: isMobile
                                                ? '12px'
                                                : '14px',
                                            }}
                                            className="text-decoration-none text-on-bg-primary inline-text text-truncate"
                                          >
                                            {name ?? 'No disponible'}
                                          </span>
                                        </div>
                                        <div className="d-flex align-items-center gap-1">
                                          {favoriteCompanies.some(
                                            (fc) => fc.id === id
                                          ) && (
                                            <span
                                              style={{
                                                width: '7px',
                                                height: '7px',
                                                borderRadius: '50%',
                                                backgroundColor: '#198754',
                                                display: 'inline-block',
                                                flexShrink: 0,
                                              }}
                                            />
                                          )}
                                          <div className="d-flex align-items-center bg-bg-tertiary rounded-pill rounded-2 gap-2 px-1">
                                            <SearchUserOutlineExtraSmallIcon />
                                            <span className="font-extra-small text-on-bg-secondary">
                                              {offers_count}
                                            </span>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </li>
                                )
                              })}
                          </ul>
                        </div>
                      )}

                      {IS_HIRING_ADVISOR && selectCompanyByHA && (
                        <div className="px-3 pt-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="text-on-bg-secondary">
                              {t('save_as_favorite')}
                            </span>
                            <span
                              className="cursor-pointer text-on-bg-primary fontSize12 border border-on-bg-primary p-1 rounded"
                              onClick={() => setSelectCompanyByHA(null)}
                            >
                              Volver
                            </span>
                          </div>
                          <input
                            className="form-label rounded border border-2 w-100 mb-2 mt-2"
                            placeholder={t('search_offer')}
                            onChange={(e) => {
                              setSearch(e.target.value.trim())
                              setPage(0)
                            }}
                          />
                          <ul className="list-unstyled">
                            {listOfJobsOffer?.offers?.map(
                              ({
                                id,
                                name,
                                position,
                                countTalentLinked,
                                category_job,
                              }) => {
                                const loadings =
                                  isLoadingAddFavorite ||
                                  isLoadingRemoveFavorite
                                const selectedId =
                                  addFavoriteVariables?.idsOffer?.[0] === id ||
                                  removeFavoriteVariables?.idsOffer?.[0] === id
                                const renderLoading = loadings && selectedId

                                return (
                                  <li
                                    key={id}
                                    className="d-flex justify-content-between align-items-center gap-2 mb-1"
                                  >
                                    {renderLoading ? (
                                      <Loader />
                                    ) : (
                                      <>
                                        <div
                                          style={{
                                            width: '100%',
                                            overflow: isMobile ? '' : 'auto',
                                          }}
                                          className="d-flex align-items-center gap-2"
                                        >
                                          <div
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              className="mycheck"
                                              checked={checkOffersFavorite?.includes(
                                                id
                                              )}
                                              onChange={() =>
                                                handleOfferSelect({
                                                  id,
                                                })
                                              }
                                            />
                                          </div>
                                          <span
                                            style={{
                                              fontSize: isMobile
                                                ? '12px'
                                                : '16px',
                                            }}
                                            className="text-decoration-none text-on-bg-primary inline-text text-truncate"
                                          >
                                            {name} |{' '}
                                            {position ??
                                              category_job?.name ??
                                              'No disponible'}
                                          </span>
                                        </div>
                                        <div className="d-flex align-items-center bg-bg-tertiary rounded-pill rounded-2 gap-2 px-1">
                                          <SearchUserOutlineExtraSmallIcon />
                                          <span className="font-extra-small text-on-bg-secondary">
                                            {countTalentLinked}
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </li>
                                )
                              }
                            )}
                            <div className="mt-2 d-flex align-items-center justify-content-center">
                              <Pagination
                                page={page}
                                setPage={setPage}
                                itemsPerPage={ITEMS_PER_PAGE}
                                totalItems={listOfJobsOffer?.offersCount}
                              />
                            </div>
                          </ul>
                        </div>
                      )}

                      {!IS_HIRING_ADVISOR && (
                        <div className="px-3 pt-3">
                          <span className="text-on-bg-secondary">
                            {t('save_as_favorite')}
                          </span>
                          <input
                            className="form-label rounded border border-2 w-100 mb-2 mt-2"
                            placeholder={t('search_offer')}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                          <ul className="list-unstyled">
                            {listOfJobsOffer?.offers?.map(
                              ({
                                id,
                                name,
                                position,
                                countTalentLinked,
                                category_job,
                              }) => {
                                const loadings =
                                  isLoadingAddFavorite ||
                                  isLoadingRemoveFavorite
                                const selectedId =
                                  addFavoriteVariables?.idsOffer[0] === id ||
                                  removeFavoriteVariables?.idsOffer[0] === id
                                const renderLoading = loadings && selectedId

                                return (
                                  <li
                                    key={id}
                                    className="d-flex justify-content-between align-items-center gap-2 mb-1"
                                  >
                                    {renderLoading ? (
                                      <Loader />
                                    ) : (
                                      <>
                                        <div
                                          style={{
                                            width: '100%',
                                            overflow: isMobile ? '' : 'auto',
                                          }}
                                          className="d-flex align-items-center gap-2"
                                        >
                                          <div
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              className="mycheck"
                                              checked={checkOffersFavorite?.includes(
                                                id
                                              )}
                                              onChange={() =>
                                                handleOfferSelect({
                                                  id,
                                                })
                                              }
                                            />
                                          </div>
                                          <span
                                            style={{
                                              fontSize: isMobile
                                                ? '12px'
                                                : '16px',
                                            }}
                                            className="text-decoration-none text-on-bg-primary inline-text text-truncate"
                                          >
                                            {name} |{' '}
                                            {position ??
                                              category_job?.name ??
                                              'No disponible'}
                                          </span>
                                        </div>
                                        <div className="d-flex align-items-center bg-bg-tertiary rounded-pill rounded-2 gap-2 px-1">
                                          <SearchUserOutlineExtraSmallIcon />
                                          <span className="font-extra-small text-on-bg-secondary">
                                            {countTalentLinked}
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </li>
                                )
                              }
                            )}
                            <div className="mt-2 d-flex align-items-center justify-content-center">
                              <Pagination
                                page={page}
                                setPage={setPage}
                                itemsPerPage={ITEMS_PER_PAGE}
                                totalItems={getOffersByCompanyData?.offersCount}
                              />
                            </div>
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>

      <Divider className="bg-on-bg-Tertiary w-100 mt-2 mb-2" />

      <div className="d-flex flex-column align-items-start gap-1 font-small-2">
        <div className="d-flex align-items-center gap-1 inline-text overflow-auto">
          <CalendarIcon />
          <span className="text-on-bg-secondary">{t('experience')}:</span>
          <span>{years?.replace('años', t('years'))}</span>
          {t('from_experience')}
        </div>
        {languaje_lang_levels?.length > 1 ? (
          <div className="d-flex align-items-center gap-2 inline-text overflow-auto">
            <TranslateIconTwo />
            <span className="text-on-bg-secondary">{t('languages')}:</span>
            <span className="text-on-bg-secondary">
              {languaje_lang_levels?.length} {t('languages')}
            </span>
          </div>
        ) : (
          <div className="d-flex align-items-center inline-text overflow-auto">
            <TranslateIconTwo />
            <span className="ms-1 font-small-2">
              {languaje_lang_levels[0]?.languaje?.name}{' '}
              {languaje_lang_levels[0]?.lang_level?.name}
            </span>
          </div>
        )}
      </div>

      <div className="d-flex flex-column flex-lg-row justify-content-center justify-content-lg-between  position-relative">
        <div className="d-flex align-items-baseline overflow-auto mt-2">
          {elementsToShow.map(({ skills_categori, id }) => (
            <Badge
              key={id}
              className="border border-on-bg-CTA-primary-selected text-on-bg-CTA-primary-selected rounded-pill me-2 font-small-3"
            >
              {skills_categori?.skill?.name || NOT_AVAILABLE}
            </Badge>
          ))}
          {showSkills && (
            <Badge
              key={idTalent}
              className="bg-bg-CTA-complementary-pressed  text-on-bg-primary rounded-pill me-2 font-small-3"
            >
              {`+${Number(talen_skills?.length) - Number(totalElementsToShow)}`}
            </Badge>
          )}
        </div>
        {!OUT_OF_THE_APP && (
          <div className="mt-3 mt-lg-0 d-flex justify-content-end align-items-center gap-3 position-relative">
            {IS_HIRING_ADVISOR && (
              <InitWhatsappChatButton
                modalId={`init-ws-chat-card-${idTalent}`}
                talentId={idTalent}
                talentName={user?.username}
                triggerClassName="btn btn-sm btn-success d-flex align-items-center gap-2"
                showLabel={false}
                triggerLabel="WhatsApp"
                onTriggerClick={(e) => e.stopPropagation()}
              />
            )}
            {(IS_ADMIN || IS_HIRING_ADVISOR || isJuniorView) && (
              <Button type="button" onClick={() => handleDownloadPdf(idTalent)}>
                <div className="d-flex align-items-center gap-2">
                  <span className="font-small-2 inline-text">
                    {t('download_pdf')}
                  </span>
                </div>
              </Button>
            )}
            <Button
              type="button"
              className="btn-white text-on-bg-primary border border-on-bg-primary"
              onClick={handleGoToReviewProfile}
            >
              <div className="d-flex align-items-center gap-2">
                <span className="font-small inline-text">
                  {t('review_profile')}
                </span>
              </div>
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default TalentCard
